module.exports = __webpack_public_path__ + "img/pdf.f1a4c5dd.png";